import React, { useEffect, useState } from 'react';
import ConfirmModal from '../../Common/ConfirmModal';

export default function MakePaymentButton({ paypayment, text = 'Make Payment', selectedMethod = 'card', orderdetails }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [data, setData] = useState({});
  const [widgetReady, setWidgetReady] = useState(false);

  const baseUrl = window.location.origin;
  const publicUrl = process.env.PUBLIC_URL || '';

  // ===============================
  // RESET
  // ===============================
  const resetPayment = () => {
    setModalOpen(false);
    setWidgetReady(false);
    setData({});
    setIsLoading(false);

    const container = document.getElementById('hyperpay-widget-container');
    if (container) container.innerHTML = '';

    delete window.wpwlOptions;
  };

  // ===============================
  // API CALL
  // ===============================
  const handlePayment = async () => {
    resetPayment();

    try {
      setIsLoading(true);
      
      console.log("Frontend Amount being submitted:", orderdetails?.post_price);

      const response = await paypayment(selectedMethod);
      const result = response?.data?.response?.result;

      console.log("Server Authorized Amount for Gateway:", result?.payable_amount);

      // FULL WALLET PAYMENT CHECK
      if (result?.payable_amount === 0) {
        window.location.href = `${baseUrl}${publicUrl}/${localStorage.getItem('laung') || 'en'}/account/paymentsuccessful/${result.transaction_id}?wallet=${selectedMethod === 'wallet' ? 1 : 0}`;
        return;
      }

      if (!result?.request_id || !result?.transaction_id) {
        console.error('Invalid HyperPay response', response);
        return;
      }

      setData({
  ...result,
  is_production: response?.data?.response?.is_production,
});
      setModalOpen(true);
    } catch (error) {
      console.error('Payment error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // ===============================
  // LOAD HYPERPAY
  // ===============================
  useEffect(() => {
    if (!modalOpen || !data?.request_id) return;

    const container = document.getElementById('hyperpay-widget-container');
    if (!container) return;

    container.innerHTML = '';

    // Configure options based on selected payment brand
    if (selectedMethod === 'applepay') {
      window.wpwlOptions = {
        style: 'plain',
        locale: 'en',
        paymentTarget: '_top',
        applePay: {
          displayName: "Pay now",
          total: { label: "Urxprt" }
        },
        onReady: () => {
          const applePayButton = container.querySelector('.wpwl-apple-pay-button');
          if (applePayButton) {
            applePayButton.setAttribute('aria-label', 'Pay with Apple Pay');
          }
        }
      };
    } else {
      window.wpwlOptions = {
        style: 'card',
        locale: 'en',
        paymentTarget: '_top',
        registrations: {
          requireCardHolder: true,
        },
        cardHolder: {
          placeholder: 'Card Holder Name',
        },
        onReady: () => {
          setWidgetReady(true);

          const input = document.querySelector('.wpwl-control-cardHolder');
          if (input) {
            input.setAttribute('required', 'true');
            input.setAttribute('minlength', '3');
          }
        },
      };
    }

    const form = document.createElement('form');
    form.className = 'paymentWidgets';
    form.setAttribute('method', 'GET');
    
    // Set brand conditionally
    if (selectedMethod === 'applepay') {
      form.setAttribute('data-brands', 'APPLEPAY');
    } else {
      form.setAttribute('data-brands', 'VISA MASTER MADA');
    }

    form.setAttribute(
      'action',
      `${baseUrl}${publicUrl}/${localStorage.getItem('laung') || 'en'}/account/paymentsuccessful/${data.transaction_id}?wallet=${selectedMethod === 'wallet' ? 1 : 0}`
    );

    const script = document.createElement('script');
const paymentBaseUrl = Number(data.is_production)
  ? "https://eu-prod.oppwa.com"
  : "https://eu-test.oppwa.com";

script.src = `${paymentBaseUrl}/v1/paymentWidgets.js?checkoutId=${data.request_id}`;
script.async = true;

    container.appendChild(form);
    container.appendChild(script);

    return () => {
      container.innerHTML = '';
      delete window.wpwlOptions;
    };
  }, [modalOpen, data, baseUrl, publicUrl, selectedMethod]);

  // ===============================
  // UI
  // ===============================
  return (
    <>
      <br></br>
      <button onClick={handlePayment} disabled={isLoading} className="buttons background-button w-100">
        {isLoading ? 'Processing...' : text}
      </button>

      {modalOpen && data?.request_id && (
        <div
          key={data.request_id}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.9)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 999,
          }}
        >
          <div
            style={{
              background: '#fff',
              width: '100%',
              height: '100%',
              padding: 20,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              //marginTop:'150px'
            }}
          >
            <div
              style={{
                marginTop: '150px',
                display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              }}
            >

            <h2>{selectedMethod === 'applepay' ? 'Authorize Apple Pay' : 'Enter Card Details'}</h2>

            {selectedMethod === 'applepay' && (
              <style>
                {`
                  #hyperpay-widget-container.apple-pay-widget {
                    flex: 0 0 auto !important;
                    margin-top: 22px;
                    min-height: 58px;
                  }

                  #hyperpay-widget-container.apple-pay-widget .wpwl-form,
                  #hyperpay-widget-container.apple-pay-widget .wpwl-group,
                  #hyperpay-widget-container.apple-pay-widget .wpwl-wrapper {
                    width: 100% !important;
                    margin: 0 !important;
                    padding: 0 !important;
                    background: transparent !important;
                    border: 0 !important;
                    box-shadow: none !important;
                  }

                  #hyperpay-widget-container.apple-pay-widget .wpwl-apple-pay-button {
                    -webkit-appearance: -apple-pay-button !important;
                    -apple-pay-button-type: pay;
                    -apple-pay-button-style: black;
                    display: block !important;
                    width: 100% !important;
                    max-width: 500px !important;
                    height: 48px !important;
                    min-height: 48px !important;
                    margin: 0 auto !important;
                    padding: 0 !important;
                    border: 0 !important;
                    border-radius: 8px !important;
                    background-color: #000 !important;
                    color: #fff !important;
                    line-height: 48px !important;
                  }
                `}
              </style>
            )}

            <div
  id="hyperpay-widget-container"
  style={{
    width: "100%",
    maxWidth: 500,
  }}
/>

{widgetReady && (
  <button
    onClick={() => setConfirmModal(true)}
    style={{
      marginTop: 20,
      width: 220,
      padding: "12px",
      background: "#f44336",
      color: "#fff",
      border: "none",
      borderRadius: 8,
      cursor: "pointer",
    }}
  >
    Cancel Payment
  </button>
)}
            </div>
          </div>
        </div>
      )}

      <ConfirmModal
        isOpen={confirmModal}
        toggle={() => setConfirmModal(false)}
        title=""
        message="Do you want to Cancel Payment?"
        onConfirm={resetPayment}
      />
    </>
  );
}
